import React, { useEffect, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../services/endpoint/endPoint";
import button from "../../../button.module.css";
import UsersList from "./child/UsersList";
// import MultiselectCheckbox from './child/MultiselectCheckbox';
import MultiselectCheckbox from "../../../common/multiselect-checkbox/MultiselectCheckbox";

const Users = () => {
  const initialState = {
    name: "",
    email: "",
    margin: "",
    password: "",
    confirmPassword: "",
    user_type: "",
    company: "",
  };
  const subUserInitialState = {
    id: "",
    subEmail: "",
    subPassword: "",
    subCurrency: "",
  };

  const userRoles = [
    { id: "super_admin", user_type: "Super Admin" },
    { id: "admin", user_type: "Admin" },
    { id: "sales_user", user_type: "Sales Admin" },
    { id: "client", user_type: "Client Admin" },
    { id: "demand", user_type: "Demand Admin" },
  ];

  const privilege = [
    { value: "impressions", label: "Impressions" },
    { value: "advertiser_cost", label: "Advertiser Cost" },
    { value: "savings", label: "Savings" },
    { value: "media_cost", label: "Media Cost" },
    { value: "cpm", label: "eCPM" },
  ];
  const [selectedPrevillage, setSelectedPrevillage] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [newUser, setNewUser] = useState(initialState);
  const [search, setSearch] = useState("");
  const [usersRole, setUsersRole] = useState(userRoles);
  const [selectedUserRole, setSelectedUserRole] = useState();
  const [isEditMode, setIsEditMode] = useState(false);

  const [subUser, setSubUser] = useState(subUserInitialState);

  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  const [errors, setErrors] = useState({});
  const [subErrors, setsubErrors] = useState({});

  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideModal1, setShowHideModal1] = useState(false);

  const [isChangePwModal, setIsChangePwModal] = useState(false);

  const [loader, setLoader] = useState(false);

  const initialChangePw = {
    password: "",
    confirmPassword: "",
  };
  const [changePw, setChangePw] = useState(initialChangePw);
  const [isPwChange, setIsPwChange] = useState(false);
  const [pwErrors, setPwErrors] = useState({});

  const getUsersTableData = () => {
    setLoader(true);
    const data = {
      name: search,
      userType: selectedUserRole?.id,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    ApiCallServices.create(END_POINTS.usersTableData, data)
      .then((res) => {
        const data = res.data.data;
        if (res.status === 200) {
          setTableData(data);
          setLoader(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const deleteUserById = (userId) => {
    console.log(userId, "***userId");
    ApiCallServices.create(END_POINTS.deleteUser, userId)
      .then((res) => {
        if (res.status === 200) {
          toast.success("User deleted successfully", {
            position: "top-right",
          });
          getUsersTableData();
        } else {
          toast.error("Failed to delete user", {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const confirmDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this User")) {
      deleteUserById(id);
    }
  };

  useEffect(() => {
    getUsersTableData();
  }, [search, selectedUserRole, sortingColumn, sortingOrder]);

  const handleInput = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const validateForm = (prev) => {
    const errors = {};
    if (!newUser?.name) errors.name = "Name is required";
    if (!newUser?.email) errors.email = "Email is required";
    if (!newUser?.password && !isEditMode)
      errors.password = "Password is required";
    if (!newUser?.confirmPassword && !isEditMode)
      errors.confirmPassword = "Confirm Password is required";
    if (newUser?.password !== newUser?.confirmPassword && !isEditMode)
      errors.confirmPassword = "Passwords do not match";
    if (!newUser?.user_type) errors.user_type = "User type is required";
    if (!/^\d{1,2}(\.\d+)?$/.test(newUser?.margin))
      errors.margin = "Margin should be between 0-99";
    if (!newUser?.margin) errors.margin = "Margin is required";
    if (prev.length < 2 && prev.length !== 0) {
      errors.previllage = "Atleast select 2 previliages";
    } else if (prev.length == 0) {
      errors.previllage = "Previllage is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validatePasswordChange = () => {
    const errors = {};
    if (!changePw.password) errors.password = "Password is required";
    if (changePw.password.length < 4)
      errors.password = "Password must be at least 4 characters";
    if (!changePw.confirmPassword)
      errors.confirmPassword = "Confirm Password is required";
    if (changePw.confirmPassword.length < 4)
      errors.confirmPassword = "Confirm Password must be at least 4 characters";
    if (changePw.password !== changePw.confirmPassword)
      errors.confirmPassword = "Passwords do not match";
    setPwErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let prev = selectedPrevillage.map((item) => item.value);
    if (!validateForm(prev)) {
      return;
    }
    let obj = { ...newUser, privilege: prev };

    if (!isEditMode) {
      ApiCallServices.create(END_POINTS.createUser, obj)
        .then((res) => {
          if (res.status === 200) {
            toast.success(res.data.message, {
              position: "top-right",
            });
            setNewUser(initialState);
            setSelectedPrevillage(null);
            document.body.removeAttribute("style");
            setShowHideModal(false);

            getUsersTableData();
          } else {
            toast.error(res.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            toast.error(error.response.data.error, {
              position: "top-right",
            });
            console.log(error.response, "===>error in getting response");
          }
        });
    } else {
      ApiCallServices.create(END_POINTS.updateUser, obj)
        .then((res) => {
          toast.success(res.data.message, {
            position: "top-right",
          });
          setIsEditMode(false);
          setNewUser(initialState);
          setSelectedPrevillage(null);
          document?.body?.removeAttribute("style");
          setShowHideModal(false);
          getUsersTableData();
        })
        .catch((error) => {
          if (error.response) {
            toast.error(error.response.data.error, {
              position: "top-right",
            });
            console.log(error.response, "===>error in getting response");
          }
        });
    }
  };

  const searchUser = (e) => {
    if (e.target.value.length > 1) {
      setSearch(e.target.value);
    } else {
      setSearch("");
    }
  };

  const getUserById = (id) => {
    ApiCallServices.create(END_POINTS.getUserById, { id: id })
      .then((res) => {
        let prev = res.data.data.privilege.split(",");
        if (res.status === 200) {
          setIsEditMode(true);
          setShowHideModal(true);
          document.body.style = "overflow: hidden";
          setNewUser(res.data.data);
          const formattedPrev = prev.map((preValue) => ({
            value: preValue,
            label: preValue,
          }));
          setSelectedPrevillage(formattedPrev);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const handlePwInput = (e) => {
    setChangePw({ ...changePw, [e.target.name]: e.target.value });
  };
  console.log(changePw);

  const changePwById = (id) => {
    console.log("change pw id =>>>", id);
    setChangePw({ ...changePw, userId: id });

    setIsChangePwModal(true);
    document.body.style = "overflow: hidden";
  };
  const handleChangePwSubmit = (e) => {
    e.preventDefault();
    if (!validatePasswordChange()) {
      return;
    }
    ApiCallServices.create(END_POINTS.changeUserPwByAdmin, changePw)
      .then((res) => {
        console.log(res);
        setIsPwChange(true);
        toast.success(res.data.message, {
          position: "top-right",
        });
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const resetChangePwModal = () => {
    setIsPwChange(false);
    setIsChangePwModal(false);
    document?.body?.removeAttribute("style");
    setChangePw(initialChangePw);
    setPwErrors({});
  };

  const updateUserStatus = (id, status) => {
    ApiCallServices.create(END_POINTS.updateUserStatus, {
      id: id,
      status: status,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message, {
            position: "top-right",
          });
          getUsersTableData();
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const confirmUpdate = (id, status) => {
    if (window.confirm("Are you sure you want to Update this User")) {
      updateUserStatus(id, status);
    }
  };

  const handleFormReset = () => {
    setIsEditMode(false);
    setShowHideModal(false);
    document?.body?.removeAttribute("style");
    setNewUser(initialState);
    setSelectedPrevillage(null);
    setErrors({});
  };

  const userRoleChange = (value) => {
    setSelectedUserRole(value);
  };

  const handlePrevillageChange = (value) => {
    setSelectedPrevillage(value);
  };

  const handleSort = (column) => {
    if (sortingColumn === column) {
      setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
    } else {
      setSortingColumn(column);
      setSortingOrder("asc");
    }
  };

  const handleHideShowModal = () => {
    setShowHideModal(true);
    document.body.style = "overflow: hidden";
  };

  const handleHideShowModal1 = (id) => {
    console.log(id, "***(*999");
    setShowHideModal1(true);
    setSubUser({ ...subUser, id: id });
    document.body.style = "overflow: hidden";
  };

  const handleSubUserReset = () => {
    setShowHideModal1(false);
    document?.body?.removeAttribute("style");
    setSubUser(subUserInitialState);
    setsubErrors({});
  };

  const validateSubUserForm = () => {
    let errors = {};
    if (subUser?.subEmail == "") {
      console.log(subUser?.subEmail, "***subUser?.subEmail");
      errors.subEmail = "Email is required";
    }
    if (!subUser?.subPassword) {
      errors.subPassword = "Password is required";
    }
    if (!subUser?.subCurrency) {
      errors.subCurrency = "Currency is required";
    }

    setsubErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddSubUser = (e) => {
    e.preventDefault();
    if (!validateSubUserForm()) {
      console.log(subErrors, "subErrorssubErrors");
      return; // Stop further execution if validation fails
    }

    let obj = {
      id: subUser.id,
      email: subUser.subEmail,
      password: subUser.subPassword,
      currency: subUser.subCurrency,
    };

    ApiCallServices.create(END_POINTS.createUser, obj)
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message, {
            position: "top-right",
          });
          setSubUser(subUserInitialState);
          document.body.removeAttribute("style");
          setShowHideModal1(false);
          getUsersTableData();
        } else {
          toast.error(res.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const handleSubUserInput = (e) => {
    setSubUser({ ...subUser, [e.target.name]: e.target.value });
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#fff"
        : state.isFocused
        ? "#6abfe94d"
        : undefined,
      color: state.isSelected ? "#000" : "black",
      padding: 10,
      display: "flex",
      alignItems: "center",
    }),
    // menu: (provided) => ({
    //   ...provided,
    //   zIndex: 9999, // Ensure the menu stays on top of other elements
    // }),
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">

      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage Users</h3>
          </div>
      </div>


        <div className="filter-wraper d-flex justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                onChange={searchUser}
                placeholder="Search name & email "
              />
            </div>
            <div className="form-group custome-select">
              <Select
                placeholder="Select User Role"
                isClearable="true"
                value={selectedUserRole}
                onChange={userRoleChange}
                options={userRoles}
                getOptionLabel={(usersRole) => usersRole.user_type}
                getOptionValue={(usersRole) => usersRole.id}
              />
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button
              type="button"
              className={`${button.btn} ${button.btnDarkBlue}`}
              onClick={handleHideShowModal}
            >
              Add New User
            </button>
          </div>
        </div>
        <UsersList
          tableData={tableData}
          onDeleteUser={deleteUserById}
          changePw={changePwById}
          getUser={getUserById}
          selectedUserRole={selectedUserRole}
          search={search}
          onSort={handleSort}
          delUser={confirmDelete}
          updateStatus={confirmUpdate}
          loader={loader}
          addsubUser={handleHideShowModal1}
        />
      </div>
      {/* change pw modal start */}
      <div className={`modal form-modal ${isChangePwModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {!isPwChange ? "Change User Password" : "User New Password"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={resetChangePwModal}
              ></i>
            </div>
            <div className="modal-body">
              {!isPwChange && (
                <form onSubmit={handleChangePwSubmit}>
                  <div className="form-wraper">
                    <div className="form-group">
                      <label>
                        Password <span className="astric">*</span>
                      </label>
                      <input
                        type="password"
                        placeholder="Enter Password"
                        name="password"
                        value={changePw.password}
                        className="form-control"
                        onChange={handlePwInput}
                      />
                      {pwErrors.password && (
                        <div className="input-error">{pwErrors.password}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Confirm Password <span className="astric">*</span>
                      </label>
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        value={changePw.confirmPassword}
                        className="form-control"
                        onChange={handlePwInput}
                      />
                      {pwErrors.confirmPassword && (
                        <div className="input-error">
                          {pwErrors.confirmPassword}
                        </div>
                      )}
                    </div>
                    <div className="text-end">
                      <button
                        type="submit"
                        className={`${button.btn} ${button.btnBlue}`}
                      >
                        Change Password
                      </button>
                    </div>
                  </div>
                </form>
              )}
              {isPwChange && (
                <form>
                  <div className="send-email d-flex align-items-center justify-content-center">
                    <label>
                      Password: <strong>{changePw.password}</strong>
                    </label>
                    {/* <button type="submit" className={`${button.btn} ${button.btnBlue}`}>Send Email to User</button> */}
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* change pw modal ends */}
      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {!isEditMode ? "Create New User" : "Update User"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={handleFormReset}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>
                      Name <span className="astric">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Name"
                      value={newUser.name}
                      name="name"
                      className="form-control"
                      onChange={handleInput}
                    />
                    {errors?.name && (
                      <div className="input-error">{errors.name}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Email <span className="astric">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Email"
                      name="email"
                      value={newUser.email}
                      className="form-control"
                      onChange={handleInput}
                    />
                    {errors?.email && (
                      <div className="input-error">{errors.email}</div>
                    )}
                  </div>
                  {!isEditMode ? (
                    <>
                      <div className="form-group">
                        <label>
                          Password <span className="astric">*</span>
                        </label>
                        <input
                          type="password"
                          placeholder="Enter Password"
                          name="password"
                          value={newUser.password}
                          className="form-control"
                          onChange={handleInput}
                        />
                        {errors?.password && (
                          <div className="input-error">{errors.password}</div>
                        )}
                      </div>
                      <div className="form-group">
                        <label>
                          Confirm Password <span className="astric">*</span>
                        </label>
                        <input
                          type="password"
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          value={newUser.confirmPassword}
                          className="form-control"
                          onChange={handleInput}
                        />
                        {errors?.confirmPassword && (
                          <div className="input-error">
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div>
                    </>
                  ) : null}
                  <div className="form-group">
                    <label>
                      User Type <span className="astric">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="user_type"
                      value={newUser.user_type}
                      onChange={handleInput}
                    >
                      <option value="" disabled>
                        Select Role
                      </option>
                      <option value="super_admin">Super Admin</option>
                      <option value="admin">Admin</option>
                      <option value="sales_user">Sales Admin</option>
                      <option value="client">Client Admin</option>
                      <option value="demand">Dmand Admin</option>
                    </select>
                    {errors?.user_type && (
                      <div className="input-error">{errors.user_type}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Margin in % <span className="astric">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Enter Margin in %"
                      name="margin"
                      value={newUser.margin}
                      className="form-control"
                      onChange={handleInput}
                    />
                    {errors?.margin && (
                      <div className="input-error">{errors.margin}</div>
                    )}
                  </div>
                  <div className="form-group custome-select multicheck">
                    <label>
                      Set Report Previllage <span className="astric">*</span>{" "}
                      <i className="note">( Atleast select 2 previliages )</i>
                    </label>
                    <Select
                      placeholder="Select Previllage"
                      isClearable="true"
                      isMulti={true}
                      value={selectedPrevillage}
                      hideSelectedOptions={false}
                      closeMenuOnSelect={false}
                      onChange={handlePrevillageChange}
                      options={privilege}
                      components={{ Option: MultiselectCheckbox }}
                      styles={customStyles}
                    />
                    {errors?.previllage && (
                      <div className="input-error">{errors.previllage}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Company</label>
                    <input
                      type="text"
                      placeholder="Enter Company Name"
                      name="company"
                      value={newUser.company}
                      className="form-control"
                      onChange={handleInput}
                    />
                  </div>
                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {!isEditMode ? "Save" : "Update"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* sub user modal */}
      <div className={`modal form-modal ${showHideModal1 ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Sub User</h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={handleSubUserReset}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleAddSubUser}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>
                      Email <span className="astric">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Email"
                      name="subEmail"
                      value={subUser.subEmail}
                      className="form-control"
                      onChange={handleSubUserInput}
                    />
                    {subErrors?.subEmail && (
                      <div className="input-error">{subErrors.subEmail}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Password <span className="astric">*</span>
                    </label>
                    <input
                      type="password"
                      placeholder="Enter Name"
                      value={subUser.subPassword}
                      name="subPassword"
                      className="form-control"
                      onChange={handleSubUserInput}
                    />
                    {subErrors?.subPassword && (
                      <div className="input-error">{subErrors.subPassword}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Select Currency <span className="astric">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="subCurrency"
                      value={subUser.subCurrency}
                      onChange={handleSubUserInput}
                    >
                      <option value="" disabled selected>
                        Select Currency
                      </option>
                      <option value="ALL">All</option>
                      {/* <option value="BASE">BASE</option> */}
                      <option value="USD">USD</option>
                      <option value="INR">INR</option>
                      <option value="CAD">CAD</option>
                      <option value="EUR">EUR</option>
                    </select>
                    {subErrors?.subCurrency && (
                      <div className="input-error">{subErrors.subCurrency}</div>
                    )}
                  </div>
                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          showHideModal || isChangePwModal || showHideModal1 ? "overlay" : ""
        }`}
      ></div>
    </>
  );
};

export default Users;
